import { FC } from 'react';
import { MerchantCategory } from '~/interfaces/MerchantCategory';
import styles from '~/styles/stores/stores-categories.module.scss';

interface CategoryItemProps {
  category: MerchantCategory;
  onClick: (name: string) => void;
}

interface CategoryItemSkeletonProps {
  loading?: boolean;
}

export const CategoryItemSkeleton: FC<CategoryItemSkeletonProps> = () => {
  return (
    <div className={styles.categoryItem}>
      <div className={`${styles.imageContainer} ${styles.skeleton}`} />
      <div className={styles.titleContainer}>
        <div className={`${styles.categoryTitle} ${styles.skeleton}`} style={{ width: '80%', height: '20px' }} />
      </div>
    </div>
  );
};

export const CategoryItem: FC<CategoryItemProps> = ({ category, onClick }) => {
  const generateFallbackImage = (name: string) => {
    const letter = name.charAt(0).toUpperCase();
    return `https://ui-avatars.com/api/?name=${letter}&size=800&background=fcfcfc&color=000000&font-size=0.5&bold=true&format=png`;
  };
  return (
    <div role="button" tabIndex={0} className={styles.categoryItem} onClick={() => onClick(category.name)}>
      <div className={styles.imageContainer}>
        <img
          src={category.thumbnail_image_url || generateFallbackImage(category.name)}
          alt={category.name}
          loading="lazy"
        />
      </div>
      <div className={styles.titleContainer}>
        <span className={styles.categoryTitle}>{category.name}</span>
      </div>
    </div>
  );
};
